import {Component, inject, OnInit, ViewChild} from '@angular/core';
import {BlockStore} from '@blocks/block/block.store';
import {TokenStore} from '@management/editor/tokens/token.store';
import {FormMetaInformation} from '../form-meta-information';
import {ActivatedRoute, Router} from '@angular/router';
import {CommonModule, DOCUMENT} from '@angular/common';
import {coerceBooleanProperty} from '@angular/cdk/coercion';
import {DesignColorsInserterModule} from '@shared/design/design-colors-inserter/design-colors-inserter.module';
import {SessionModule} from '../../session/session/session.module';
import {FormsModule} from '../forms.module';
import {FormsPreviewComponent} from '../forms-preview/forms-preview.component';
import {FormUnavailableModule} from '@shared/form-unavailable/form-unavailable.module';
import {SessionHeaderComponent} from '../../session/session/session-header/session-header.component';
import {ScrollingModule} from '@shared/scrolling/scrolling.module';
import {TranslocoModule} from '@ngneat/transloco';
import {Title} from '@angular/platform-browser';

@Component({
  selector: 'app-forms-wrapper',
  templateUrl: './forms-wrapper.component.html',
  styleUrls: ['./forms-wrapper.component.scss'],
  imports: [
    CommonModule,
    DesignColorsInserterModule,
    SessionModule,
    FormsModule,
    FormsPreviewComponent,
    FormUnavailableModule,
    ScrollingModule,
    TranslocoModule
  ],
  standalone: true
})
export default class FormsWrapperComponent implements OnInit {
  route = inject(ActivatedRoute);
  router = inject(Router);
  document = inject(DOCUMENT);
  blockStore = inject(BlockStore);
  tokenStore = inject(TokenStore);
  title = inject(Title);

  formMetaInformation: FormMetaInformation;
  publicToken: string;
  isEmbedded = false;
  backgroundColor: string;

  startButton: HTMLElement;
  tosCheckbox: HTMLElement;

  @ViewChild('sessionHeaderComponent') sessionHeaderComponent: SessionHeaderComponent;

  async ngOnInit() {
    const queryParams = this.route.snapshot?.queryParams;
    this.isEmbedded = queryParams?.embedded != null ? coerceBooleanProperty(queryParams?.embedded) : false;

    setTimeout(() => {
      this.startButton = document.querySelector<HTMLButtonElement>('#start-button');
      this.tosCheckbox = document.querySelector<HTMLElement>('pl-session-tos-checkbox');
    }, 300);

    if (queryParams?.backgroundColor != null) {
      this.backgroundColor = decodeURIComponent(queryParams?.backgroundColor);

      // Currently the background color is defined by the body. So why not just set it there?
      this.document.body.style.backgroundColor = this.backgroundColor;
    }

    this.formMetaInformation = this.route.snapshot.data.formMetaInformation;
    this.publicToken = this.route.snapshot.params.token;

    this.title.setTitle([this.formMetaInformation.name, this.formMetaInformation.organization_name, 'Paperless'].join(' | '));

    if (this.formMetaInformation.blocks?.length > 0) {
      this.blockStore.updateBlocks(this.formMetaInformation.blocks);
    }

    // When the form is embedded or password protected we show the request modal directly
    if (this.isEmbedded || this.formMetaInformation.password_protected && this.formMetaInformation.blocks?.length <= 0) {
      await this.start();
    }
  }

  async start() {
    await this.router.navigate(['', {outlets: {modal: ['fm', this.publicToken, 'request']}}], {queryParamsHandling: 'preserve'});
  }

  focusStartButton() {
    (document.querySelector('#start-button') as HTMLElement).focus();
  }

  action() {
    if (this.tosCheckbox != null) {
      this.tosCheckbox.querySelector('input').focus();
      return;
    }

    if (this.startButton != null) {
      this.startButton.click();
    } else {
      this.focusPage();
    }
  }

  focusPage() {
    const firstFocusableElement = document.body
      .querySelector('app-page')
      .querySelector('a[href], button, input:not([type="file"]), textarea, select, details, [tabindex]:not([tabindex="-1"])') as HTMLElement;

    firstFocusableElement.focus();
  }
}
